<p-dialog
  header="Detalle de Orden de Compra"
  [(visible)]="visible"
  [modal]="true"
  (onHide)="onHideDataDialog()"
  [style]="{ width: '80%' }"
>
  <div class="field col-12 md:col-12 mb-4">
    <p-fieldset legend="Detalles del documento" [toggleable]="true">
      <div class="grid">
        <div class="field col-12 md:col-4">
          <label>
            <b> Fecha de Factura: </b
            >{{
              detailPurchaseOrder['issue_at'] | date: 'shortDate'
            }}</label
          >
        </div>

        <div class="field col-12 md:col-4">
          <label
            ><b>Documento Orden de Compra:</b>
            {{ detailPurchaseOrder['numberDocumentPurchaseOrder'] }}</label
          >
        </div>

        <div class="field col-12 md:col-4">
          <label
            ><b>Documento Factura:</b>
            {{ detailPurchaseOrder['numberDocument'] }}</label
          >
        </div>
      </div>
    </p-fieldset>
  </div>
  <ami-table-actions
    [settings]="table.settings"
    [data]="table.data"
  ></ami-table-actions>
</p-dialog>
